import React, { useState} from "react";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { useTheme } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import useStyles from "./styles.js";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import {
  StyledButtonPrimary,
  StyledTypographyBlack,
} from "../../Commons/styledTabs";
import OtpInput from "react-otp-input";

const InputOtp = ({
  verifyOtp,
  requestOtp,
  isTimerPlaying = false,
  isDisabled = false,
  setIsDisabled,
  setIsTimerPlaying,
  otpError = {},
  deskTopView = false,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const [otp, setOtp] = useState("");

  const handleOtpResend = () => {
    if (isDisabled) return;
    requestOtp(null);
  };

  const ResendOtpTimer = () =>
    isTimerPlaying ? (
      <div style={{ marginRight: 0, marginLeft: 0, paddingTop: 5 }}>
        <CountdownCircleTimer
          isPlaying={isTimerPlaying}
          durationSeconds={15}
          strokeWidth={4}
          size={45}
          onComplete={() => {
            setIsDisabled(false);
            setIsTimerPlaying(false);
          }}
          colors={[[theme.agentTheme.primary.main]]}
          renderTime={(value) => (
            <div className={classes.timer}>
              <div
                className={classes.value}
                style={{ color: theme.agentTheme.background.foreground }}
              >
                {value}
              </div>
            </div>
          )}
        />
      </div>
    ) : (
      <div></div>
    );

  return (
    <Box>
      <StyledTypographyBlack
        variant="h4"
        style={{
          textAlign: "center",
          color: theme.agentTheme.background.primary_text,
        }}
      >
        Check your Phone for OTP
      </StyledTypographyBlack>
      <Box
        width={"90%"}
        m={"auto"}
        textAlign={"center"}
        mt={deskTopView ? "20%" : "10%"}
      >
        <Box textAlign={"left"} width={"100%"}>
          <InputLabel
            style={{
              paddingBottom: "1rem",
              color: theme.agentTheme.text.small_text_color,
            }}
          >
            Enter OTP
          </InputLabel>
          <OtpInput
            value={otp}
            onChange={(code) => setOtp(code)}
            numInputs={4}
            separator={<span style={{ width: "8px" }}></span>}
            isInputNum={true}
            shouldAutoFocus={true}
            inputStyle={{
              border: otpError["status"]
                ? `1px solid ${theme.agentTheme.destructive.main}`
                : `1px solid ${theme.agentTheme.primary.main}`,
              borderRadius: "8px",
              width: deskTopView ? "50px" : "40px",
              height: "50px",
              fontSize: "12px",
              background: theme.agentTheme.card.main,
              color: theme.agentTheme.card.foreground,
              fontWeight: "400",
            }}
            focusStyle={{
              border: otpError["status"]
                ? `1px solid ${theme.agentTheme.destructive.main}`
                : `1px solid ${theme.agentTheme.border.main}`,
              outline: "none",
            }}
          />
          {otpError["status"] && (
            <Typography
              variant="caption"
              style={{ color: theme.agentTheme.destructive.main }}
            >
              {otpError["msg"]}
            </Typography>
          )}
        </Box>
      </Box>
      <Box mt={"30%"}>
        <StyledButtonPrimary
          variant="extended"
          size="large"
          onClick={() => {
            verifyOtp(otp);
          }}
          className={classes.buttonWidth}
        >
          VERIFY
        </StyledButtonPrimary>
        <Box
          display={"flex"}
          flexDirection="row"
          textAlign={"center"}
          justifyContent="center"
          mt={1}
        >
          <ResendOtpTimer />
          <Typography
            className={
              isDisabled
                ? classes.disabledResendOtpStyle
                : classes.resendOtpStyle
            }
            onClick={() => handleOtpResend()}
          >
            RESEND OTP
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default InputOtp;
